import { render } from "./orderusedrecordmodel.vue?vue&type=template&id=1d68a7a5"
import script from "./orderusedrecordmodel.vue?vue&type=script&lang=ts"
export * from "./orderusedrecordmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script